import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const container = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s24,
});

export const section = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s32,
  ...responsiveStyle({
    mobile: {
      padding: `${space.s24}px ${space.s16}px`,
    },
    tablet: {
      padding: `${space.s32}px ${space.s40}px`,
    },
  }),
});

export const subSection = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
});

export const medalsContainer = style({
  display: 'flex',
  gap: space.s56,
});

export const medalItem = style([
  typography['labelMd'],
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s8,
  },
]);

export const deadline = style([
  typography['bodyMd'],
  {
    color: themeVars.container.foreground.secondary,
  },
]);

export const latestSubmissionsHeader = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s16,
});
export const latestSubmissions = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s24,
});

export const tournamentPageStatus = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s8,
  ...typography.bodyMd,
  color: themeVars.container.foreground.secondary,
});
